import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  location: string;
  quote: string;
  role?: string;
}
export function TestimonialCard({
  name,
  age,
  location,
  quote,
  role
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 relative" data-id="element-223">
      <div className="flex gap-1 mb-4 text-yellow-400" data-id="element-224">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-225" />)}
      </div>

      <p className="text-gray-700 italic mb-6 leading-relaxed text-lg" data-id="element-226">
        "{quote}"
      </p>

      <div className="flex items-center gap-3 border-t border-gray-100 pt-4" data-id="element-227">
        <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-lg" data-id="element-228">
          {name.charAt(0)}
        </div>
        <div data-id="element-229">
          <h4 className="font-bold text-gray-900 text-sm" data-id="element-230">
            {name}, {age}
          </h4>
          <p className="text-xs text-gray-500" data-id="element-231">{location}</p>
          {role && <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-232">{role}</p>}
        </div>
      </div>
    </div>;
}